<template>
  <div class="listeRecapInventaire mb-5">
   <div class="container">
    <div class="links linksInventaire">
      <a class="download" @click="downloadDatasInventaire"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="0 0 16 16">
        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z"/>
      </svg>Exporter vers CSV</a>
    </div>
    <div class="encart">
      <div class="inventaire">
        <div class="entete">
          <p class="petit">Dans un souci d'expérience utilisateur, veuillez scroller pour faire apparaitre la suite du tableau</p>
        </div>
        <table class="articlesListe">
          <thead>
            <tr>
              <th>Code</th>
              <th>Désignation 1</th>
              <th>Désignation 2</th>
              <th>Désignation 3</th>
              <th>Stock actuel</th>
              <th>Quantité comptée</th>
              <th>Diff</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(article, index) in articles" :key="article.id" :value="article.coarti" :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'">
              <td>{{ article.coarti }}</td>
              <td>{{ article.desa1 }}</td>
              <td>{{ article.desa2 }}</td>
              <td>{{ article.desa3 }}</td>
              <td>{{ article.qte }}</td>
              <td>{{ article.quantite }}</td>
              <td>{{ article.diff }}</td>
            </tr>
          </tbody>
          
        </table>
        
      </div>
    </div>
    
  
    
   </div>
    
      

  </div>
    
</template>

<script>
import axios from '@/components/axiosConfig.js'



export default {
  data() {
    return {
      articles: [],
      date: null,
      loggedInEmail: null,
      utilisateur: '',

      nom: '',
      prenom: '',
    }
  },
  created() {
    

    this.date = this.$route.params.date;
    this.nom = this.$route.params.nom;
    this.prenom = this.$route.params.prenom;

    this.utilisateur = this.$route.params.nom + " " + this.$route.params.prenom;

    
  },
  mounted() {
    

    axios.post('https://www.simef.fr/espace-client/api/getRecapInventaire.php', {
      date: this.date,
      nom: this.nom,
      prenom: this.prenom
    })
    .then(response => {
      this.articles = response.data;
    })
    .catch(error => {
      console.error(error);
      
    });
  },
  methods: {
    downloadDatasInventaire() {
      axios.post('https://www.simef.fr/espace-client/api/downloadDatasInventaire.php', {
        date: this.date,
        nom: this.nom,
        prenom: this.prenom,
        utilisateur: this.utilisateur,
      })
      .then(response => {
             // Récupérer le lien retourné par le backend
             const lienTelechargement = response.data.lien;
            // Télécharger le fichier en ouvrant le lien dans une nouvelle fenêtre ou un nouvel onglet
            window.open(lienTelechargement, '_blank');
      })
      .catch(error => {
          console.log(error);
      });
    }
  }
  
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;

  .linksInventaire {
    justify-content: center;
    margin-top: 20px;
  }

  .negative-diff {
    color: red!important;
  }
  .positive-diff {
    color: #00d712!important;
  }
</style>
